export enum BikeState {
    Running = 10,
    Docked = 20,
    ParkedVertically = 30,
    ParkedHorizontally = 31,
}